import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { Manufacturer } from '../../models/manufacturer';
import { ManufacturerService } from './manufacturer.service';

export const manufacturerResolver: ResolveFn<Manufacturer> = (route, state) => {
  const manufacturerService = inject(ManufacturerService)

  return manufacturerService.fetchManufacturerById(Number(route.paramMap.get('id')))
    .pipe(map(resp => resp.data))
};
